module.exports = __webpack_public_path__ + "static/media/TelaSaqueReaportePT.7b570efd.png";